import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { Check, ArrowLeft } from "lucide-react";
import { Reveal, Lines, ParallaxPhoto, HeroVideo } from "../components/motion";
import { CtaBand } from "../components/shared";
import { QuoteLink } from "../components/QuotePanel";
import { imgProps } from "../components/media";
import { SERVICES, dim } from "../data/site";

export default function ServizioDettaglio() {
  const { servizioId } = useParams();
  let svc = SERVICES.armata.find((s) => s.id === servizioId);
  let kind = "Vigilanza armata";
  if (!svc) {
    svc = SERVICES.nonarmata.find((s) => s.id === servizioId);
    kind = "Vigilanza non armata";
  }
  if (!svc) return <Navigate to="/servizi" replace />;
  const isIll = svc.img.endsWith(".svg");
  const all = [...SERVICES.armata, ...SERVICES.nonarmata];
  const collegati = (svc.col || []).map((id) => all.find((s) => s.id === id)).filter(Boolean);

  return (
    <>
      <section className="hero short">
        {servizioId === "sala-conta" ? (
          <HeroVideo src="/assets/video/loop-sala-conta-1080.mp4" poster="/assets/video/loop-sala-conta-poster.jpg" />
        ) : (
          <ParallaxPhoto url={svc.img} veil={!isIll} />
        )}
        <div className="hero-in">
          <p className="h-kick">
            <span className="dash" /> {kind} <span className="dash" />
          </p>
          <Lines lines={[svc.name]} baseDelay={0.2} />
          <p className="hero-sub">{svc.desc}</p>
          <div className="hero-ctas">
            <QuoteLink servizio={servizioId} className="btn" testid="detail-cta-preventivo">
              Richiedi un preventivo
            </QuoteLink>
            <Link to="/servizi" className="btn ghost" data-testid="detail-cta-tutti">
              <ArrowLeft size={17} /> Tutti i servizi
            </Link>
          </div>
        </div>
      </section>

      <section className="sec" data-testid="detail-body">
        <div className="wrap" style={{ display: "flex", flexWrap: "wrap", gap: "48px 90px" }}>
          <Reveal style={{ flex: "1 1 400px", minWidth: 0 }}>
            <div className={isIll ? "illpanel" : "phframe tall"}>
              <img {...imgProps(svc.img, { sizes: "(max-width: 760px) 92vw, 560px" })} alt={svc.name} />
            </div>
          </Reveal>
          <Reveal delay={0.08} style={{ flex: "1 1 480px", minWidth: 0 }}>
            <span className="svc-kind">{kind}</span>
            <h2 className="h3" style={{ marginBottom: 16 }}>{svc.name}</h2>
            <p style={{ color: "var(--muted)", margin: 0 }}>{svc.desc}</p>
            <p className="ideale">
              <strong>Ideale per</strong> — {svc.ideale}
            </p>
            <p style={{ margin: "26px 0 0", fontWeight: 700 }}>Cosa include</p>
            <ul className="includes">
              {svc.inc.map((x) => (
                <li key={x}>
                  <Check size={17} className="ck" aria-hidden="true" /> {x}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </section>

      {collegati.length > 0 && (
        <section className="sec-mist sec" style={{ paddingTop: 90 }} data-testid="detail-collegati">
          <div className="wrap">
            <Reveal className="sec-head">
              <p className="kick">Servizi collegati</p>
              <h2 className="h3">Spesso si attivano insieme</h2>
            </Reveal>
            <div className="cards" style={{ gridTemplateColumns: `repeat(${collegati.length}, minmax(0,1fr))` }}>
              {collegati.map((c, i) => (
                <Reveal key={c.id} delay={i * 0.07}>
                  <Link to={`/servizi/${c.id}`} className="card" data-testid={`detail-col-${c.id}`}>
                    <span className="num">{c.id === "trasporto-valori" ? "05" : c.id === "custodia-valori" ? "06" : c.id === "sala-conta" ? "07" : "08"}</span>
                    <h3>{c.name}</h3>
                    <p>{c.desc}</p>
                    <span className="more">Scopri di più</span>
                  </Link>
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      )}

      <CtaBand testid="detail-cta" />
    </>
  );
}
